import { render, staticRenderFns } from "./ChallengeTranslationsPage.vue?vue&type=template&id=1c00a5da&"
import script from "./ChallengeTranslationsPage.vue?vue&type=script&lang=js&"
export * from "./ChallengeTranslationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports